import { Component, Mixins, Prop } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { DataModules } from "@/store/modules/data";
import store from "@/store";
import { ITemplateChannel, ITemplateRecipientType } from "@/models/templates";

@Component
export default class TemplatesChannelsMixin extends Mixins(RequestPromises) {
  // Props

  @Prop()
  public scope!: string;

  // Computed

  public get channels() {
    return store.getters[`data/listArray`]({
      storeModule: DataModules.NOTIFICATIONS_CHANNELS,
      scope: this.scope
    }) as ITemplateChannel[];
  }

  public get allRecipientTypes() {
    return this.channels.flatMap(channel =>
      channel.recipient_types?.map(rt => ({ ...rt, channel }))
    ) as ITemplateRecipientType[];
  }

  // Life-cycle methods

  public beforeDestroy() {
    store.dispatch("data/binList", {
      storeModule: DataModules.NOTIFICATIONS_CHANNELS,
      scope: this.scope,
      vm: this
    });
  }

  // Methods
  public findByCode(code: ITemplateChannel["code"]) {
    return this.channels?.find(i => i.code === code);
  }

  public getAll() {
    return store.dispatch(`data/${DataModules.NOTIFICATIONS_CHANNELS}/list`, {
      vm: this,
      scope: this.scope,
      params: {
        limit: 0,
        order: "name",
        with: "recipient_types.category.params"
      }
    });
  }
}
